import { authPost } from "../../common/redux/ApiClient";

const baseUrl = "35.240.204.237/es3KioskApi";

export function postAgent21(params, isDefault) {
  return authPost(`${baseUrl}/Agent21.ashx`, params, undefined, isDefault);
}
